export type TSimpleQueryBuilder = {
    query: any,
    updateQuery: Function,
    resourceName: string,
    dataChoice: any
}

export enum ESimpleQueryOperators {
    is = "is",
    or = "or",
    and = "and",
    not = "not"
}

export type TSimpleQueryIs = any | string

export type TSimpleQueryOr = any | Array<string | any>

export type TSimpleQueryAnd = any | Array<string | any>

export type TSimpleQueryNot = any | string